<template lang="pug">
  .admin
    table
      tr
        th
        th Status
        th Name
        th School
        th Email
        th Phone
        th Address
        th
      tr(v-for="(student, index) in students")
        td
          img(:src="base + 'images/' + student.url")
        td
          select(name="status", v-model="student.status")
            option(value="NEED INFORMATION") NEED INFORMATION
            option(value="HAVE INFORMATION") HAVE INFORMATION
            option(value="DECEASED") DECEASED
        td
          input(v-model="student.name")
        td
          select(name="school", v-model="student.school")
            option(value="West") West
            option(value="East") East
        td
          input(v-model="student.email")
        td
          input(v-model="student.phone")
        td
          textarea(v-model="student.address")

    transition(name="fade")
      .modal(v-if="selected > -1", @click="close")
        .image(@keyup.right="next")
          img(:src="base + 'images/' + images[selected].url")
</template>

<script>

import axios from 'axios'

const base = (process.env.NODE_ENV === 'production') ? '/' : 'http://cb1970.com/'

export default {
  name: 'Admin',
  components: {
  },
  data () {
    return {
      base,
      students: [],
      selected: -1
    }
  },
  mounted () {
    axios.get(`${base}api/students/get.php`)
      .then(result => {
        console.log(result)
        this.students = result.data
      })
  },
  computed: {
  },
  methods: {
    select (index) {
      //console.log(index)
      this.selected = index
      document.body.addEventListener('keyup', this.navigate)
    },
    close () {
      this.selected = -1
      document.body.removeEventListener('keyup', this.navigate)
      //console.log('rmoved')
    },
    navigate (e) {
      //console.log(e.code)
      if (e.code === 'ArrowRight') {
        this.selected += 1
        if (this.selected >= this.students.length) {
          this.selected = 0
        }
      } else if (e.code === 'ArrowLeft') {
        this.selected -= 1
        if (this.selected < 0) {
          this.selected = this.students.length - 1
        }
      } else if (e.code === 'Escape') {
        this.close()
      }
    }
  }
}
</script>

<style lang="stylus">
.admin
  
  table
    text-align left
    img
      max-height 100px
      vertical-align top
    th, td
      padding 10px
  .modal
    align-items center
    justify-content center
    background-color rgba(0,0,0,.5)
    display flex
    position fixed
    top 0
    right 0
    left 0
    bottom 0
    img
      border 2px solid #fff
      height 90vh
      vertical-align top
      
  .button
    background-color #4287f5
    color #fff
    display block
    padding 10px
    text-align center
    text-decoration none
    
  input,
  textarea,
  select
    font-size 16px
    padding 5px

.fade-enter-active, .fade-leave-active
  transition opacity .3s
.fade-enter, .fade-leave-to
  opacity 0
  
</style>
